import React from "react";
import Header from "../components/Page/Header";
import useSWR, { useSWRPages } from "swr";

import { API } from "../config";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import TakeUser from "../components/WaitingRoom/TakeUser";
import MemberAvatar from "./client/MemberAvatar";
import { api } from "../lib/api";
export default () => {
  const { pages, isLoadingMore, isReachingEnd, loadMore } = useSWRPages(
    // page key
    "asa--rom",

    // page component
    ({ offset, withSWR }) => {
      const { data: projects } = withSWR(
        // use the wrapper to wrap the *pagination API SWR*
        useSWR(
          `${API}/channels?page=${
            offset || 1
          }&waiting=true&lastMessageSeen=false&limit=10&asa=true`,
          api,
          {
            refreshInterval: 10000,
          }
        )
      );

      if (!projects) {
        return (
          <div style={{ padding: 15, textAlign: "center" }}>Loading...</div>
        );
      }

      const projectData = projects.data.data;
      return projectData.map((project) => (
        <TableRow key={project._id}>
          <TableCell component="th" scope="row">
            <MemberAvatar
              src={project.member.profile.picture}
              alt={project.member.username}
              online={project.member.online}
            />
          </TableCell>
          <TableCell component="th" scope="row">
            {project.member.username}
          </TableCell>
          <TableCell align="left">
            <div style={{ maxWidth: 300, overflow: "hidden" }}>
              {project.lastMessage}
            </div>
          </TableCell>

          <TableCell align="right">{project.user.username}</TableCell>

          <TableCell align="right">
            <Avatar
              src={project.user.profile.picture}
              style={{ float: "right" }}
            />
          </TableCell>
          <TableCell align="right">
            <TakeUser data={project} />
          </TableCell>
        </TableRow>
      ));
    },

    // get next page's offset from the index of current page
    (SWR, index) => {
      // there's no next page
      if (
        SWR.data &&
        SWR.data.data.pagination.total <= SWR.data.data.pagination.current
      )
        return null;

      // offset = pageCount × pageSize
      return SWR.data && SWR.data.data.pagination.current + 1;
    },

    // deps of the page component
    []
  );

  return (
    <React.Fragment>
      <Header title="Asa" />

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Image</TableCell>
              <TableCell>Client</TableCell>
              <TableCell align="left">Message</TableCell>
              <TableCell align="right">Profile</TableCell>
              <TableCell align="right">Image</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{pages}</TableBody>
        </Table>
      </TableContainer>

      <Button
        onClick={loadMore}
        disabled={isReachingEnd || isLoadingMore}
        style={{ margin: "30px auto", display: "block" }}
      >
        {isLoadingMore
          ? ". . ."
          : isReachingEnd
          ? "No more clients in asa"
          : "Load more"}
      </Button>
    </React.Fragment>
  );
};
